import {Alert, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
//constants

//style
import './VerifyEmailModal.scss'
import React from 'react'
import {Link, useNavigate} from 'react-router-dom'
import OTPInput from 'react-otp-input'
import {KTSVG} from '../../../../_metronic/helpers'
import {
  fetchAsyncVerifyemailOtp,
  sendEmailOtp,
} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'

interface modalTypes {
  show: boolean
  handleClose: any
  email: string
  data: any
  mobile: number
}

const VerifyEmailOtpModal = ({show, handleClose, email, data, mobile}: modalTypes) => {
  const dispatch = useDispatch()
  const [OTP, setOTP] = useState<any>()
  const [isResendCode, setIsResendCode] = useState(0)

  const ResendEmailOtp = (e: any) => {
    e.preventDefault()
    let body = {
      email: email,
    }
    dispatch(sendEmailOtp(body)).then((res: any) => {
      if (res['type'] === 'sendEmailOtp/fulfilled' && res['payload']) {
        const data = res['payload']['data']
        if (data && data['message'] && data['message'] === 'Resent') {
          setIsResendCode(isResendCode + 1)
        }
      }
    })
  }

  const handleClick = () => {
    handleClose(false)
  }

  useEffect(() => {
    if (!show) {
      setIsResendCode(0)
    }
  }, [show])

  const handleEnter = (event: any) => {
    const data = {
      code: OTP,
      email: email,
      type: 'SIGNUP_EMAIL',
    }
    dispatch(fetchAsyncVerifyemailOtp(data)).then(({payload}: any) => {
      payload?.status ? handleClose() : setOTP('')
    })

    event.preventDefault()
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px h-auto'
        show={show}
        onHide={handleClose}
      >
        <form className='form w-100' noValidate>
          <div className='container'>
            <div className='modal-header'>
              <h2>Email Verification</h2>
              <div className='btn btn-icon btn-sm' onClick={handleClick}>
                <Link to='/auth/registration'>
                  <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                </Link>
              </div>
            </div>

            <div className='modal-body'>
              <div className='fw-bold d-flex justify-content-center mb-4'>
                {`we have sent a verification link to ${email} please click the link in the email to verify your account. if you cannot find the email please check your spam or contact us on (03) 8506 0546or support@cellcast.com`}
              </div>
              {isResendCode === 0 ? (
                <span className='d-flex justify-content-center mt-3'>
                  Didn't get a code ?{' '}
                  <a className='ms-1 text-primary' href='#' onClick={ResendEmailOtp}>
                    Resend code
                  </a>
                </span>
              ) : (
                <span className='d-flex justify-content-center mt-3'>
                  <Alert variant={'success'} className='w-500px alert-message'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2x svg-icon-success me-4'
                    />
                    The new code has been successfully sent to your email.
                  </Alert>
                </span>
              )}
            </div>
          </div>
        </form>
      </Modal>
    </>
  )
}

export default React.memo(VerifyEmailOtpModal)
